import React from "react";
import FieldLabel from "../../../components/label";
import ChipSelect from "../../../components/chipSelect";
import { withStyles } from "@mui/styles";
import { useStyles } from "../indexFormStyles";
import { Box, TextField } from "@mui/material";

function NomineeEmailDetails({
  classes: { borderBgColorContainer, formGroup },
  errorMessage,
  form,
  handleChange,
  handleChangeChipSelect,
  options,
}) {
  return (
    <Box className={borderBgColorContainer} p={1} mt={2}>
      <Box className={formGroup} pt={0}>
        <FieldLabel label={"Nominee Email Available*"} />
        <ChipSelect
          fieldname={"nominee_email_available"}
          handleChange={handleChangeChipSelect}
          options={options.availableOrNot}
          selectedItem={form.nominee_email_available}
          isMinWidth={true}
        />
      </Box>

      {form.nominee_email_available === "Available" && (
        <>
          <Box className={formGroup} pt={0} pb={0}>
            <FieldLabel label={"Email same as the Owner of the Policy*"} />
            <ChipSelect
              fieldname={"nominee_email_same_as_owner"}
              handleChange={handleChangeChipSelect}
              options={options.sameOrDifferent}
              selectedItem={form.nominee_email_same_as_owner}
              isMinWidth={true}
            />
          </Box>

          {form.nominee_email_same_as_owner === "Different" && (
            <Box className={formGroup} pt={0}>
              <FieldLabel label={"Nominee Email"} />
              <TextField
                id="standard-basic"
                variant="outlined"
                value={form.nominee_email}
                name="nominee_email"
                onChange={handleChange}
                autoComplete="off"
                helperText={errorMessage.nominee_email}
                fullWidth
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(NomineeEmailDetails);
